export default __webpack_public_path__ + "static/8-fbd14176482101f153328c2b26994ec2.jpg";